import { event, GtagEvent } from "./event";

export interface Exception extends GtagEvent{
    description?:string;
    fatal?:boolean;
}

export const exception = ($_?:Exception) => event('exception',$_);